import { FeatureFlag } from '@mews-commander/enums';
import { FormHiddenInput, lt, useFeatureFlag } from '@mews/framework';
import { ProcessPaymentFormField } from '../forms/ProcessPayment/ProcessPaymentFormSchema';
import { ReservationAsyncSelect } from '../ReservationAsyncSelect/ReservationAsyncSelect';
import { useDefaultFormContext } from '../forms/ProcessPayment/useDefaultFormValues';
import { InvoiceAsyncSelect } from '../InvoiceAsyncSelect/InvoiceAsyncSelect';
import { useGetAccountIsCompanySuspense } from '../../../accounts';
import { LinkPaymentPlanToPaymentSelect } from './LinkPaymentPlanToPaymentSelect';

export const PaymentCommonSection = ({
    hideLinkPaymentToPlan = false,
    hideInvoiceSelect = false,
}: {
    hideLinkPaymentToPlan?: boolean;
    hideInvoiceSelect?: boolean;
}) => {
    const reservationLinkEnabled = useFeatureFlag(FeatureFlag.reservationLinkToPaymentsEnabled);
    const isPaymentPlanEnabled = useFeatureFlag(FeatureFlag.paymentPlanEnabled);
    const { canLinkInvoicesConfig, accountId, isLinkingInvoiceDropdownVisible } = useDefaultFormContext();
    const { data: isCompany } = useGetAccountIsCompanySuspense({ accountId });

    const {
        defaultFormValues: { serviceOrderId },
        readOnlyFormFields: { isServiceOrderIdReadOnly },
        setServiceOrderId,
    } = useDefaultFormContext();

    const onReservationChange = ({
        defaultValue,
        finalDefaultValue,
    }: {
        defaultValue?: string | null;
        finalDefaultValue: string | null;
    }) => {
        if (!defaultValue) {
            setServiceOrderId(finalDefaultValue);
        }
    };

    const invoiceSelect =
        !hideInvoiceSelect && isLinkingInvoiceDropdownVisible && canLinkInvoicesConfig ? (
            <InvoiceAsyncSelect name={ProcessPaymentFormField.InvoiceIds} />
        ) : undefined;

    const reservationSelect =
        isLinkingInvoiceDropdownVisible && !canLinkInvoicesConfig && reservationLinkEnabled && !isCompany ? (
            <ReservationAsyncSelect
                name={ProcessPaymentFormField.ServiceOrderId}
                label={lt('ProcessPaymentLinkPaymentToReservationReservationSelectLabel')}
                accountId={accountId}
                onChange={(_, s) => setServiceOrderId(s as string)}
                defaultValue={serviceOrderId}
                readOnly={isServiceOrderIdReadOnly}
                placeholder={lt('ProcessPaymentLinkPaymentToReservationReservationSelectionPlaceholderNew')}
                onReservationChange={onReservationChange}
            />
        ) : undefined;

    const paymentPlanSelect = !hideLinkPaymentToPlan && isPaymentPlanEnabled && !isCompany && (
        <LinkPaymentPlanToPaymentSelect accountId={accountId} />
    );

    return (
        <>
            <FormHiddenInput name={ProcessPaymentFormField.CustomerId} />
            <FormHiddenInput name={ProcessPaymentFormField.BillId} />
            {invoiceSelect}
            {reservationSelect}
            {paymentPlanSelect}
        </>
    );
};
